import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { siteQuery } from '@/queries/site.query'

export const Route = createFileRoute('/_dashboard/site/$id/information/add-work/')({
  loader({ params, context: { queryClient } }) {
    return queryClient.ensureQueryData(siteQuery(params.id))
  },
  pendingComponent: PendingComponent,
})
